import React from "react";
import { TrendingUp, TrendingDown, Target, FileText } from "lucide-react";
import { useSelector } from "react-redux";
import { getFeedbackForm } from "../../../../redux/reducer/incbotFeedbackReducer";

const PsychometricFinalRemarksView: React.FC = () => {
  const feedbackForm = useSelector(getFeedbackForm);
  const report = feedbackForm?.psychometricOverallReport;

  const sections = [
    {
      title: "Strengths",
      icon: <TrendingUp className="w-4 h-4 md:w-5 md:h-5" />,
      color: "text-blue-600",
      items: report?.strengths || [],
    },
    {
      title: "Weaknesses",
      icon: <TrendingDown className="w-4 h-4 md:w-5 md:h-5" />,
      color: "text-red-600",
      items: report?.weaknesses || [],
    },
    {
      title: "Areas of Progress",
      icon: <Target className="w-4 h-4 md:w-5 md:h-5" />,
      color: "text-purple-600",
      items: report?.areas_of_progress || [],
    },
  ].filter((section) => section.items.length > 0);

  const conclusion = String(report?.conclusion || "").trim();
  const position = String(report?.position || "").trim();

  if (sections.length === 0 && !conclusion) {
    return (
      <div className="p-3 md:p-6">
        <div className="bg-white p-4 md:p-6 rounded-lg border border-gray-200">
          <p className="text-gray-600 text-sm md:text-base">
            No psychometric final remarks are available for this interview.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-3 md:p-6">
      <div className="md:hidden print:flex w-100 p-1 print:p-2 rounded-md border-b-4 border-teal-500 bg-teal-50 text-teal-500 text-md print:text-xl flex justify-center font-semibold mb-3 md:mb-6">
        Final Remarks
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-8">
        {sections.map((section) => (
          <div
            key={section.title}
            className="bg-white p-4 md:p-6 rounded-lg border border-gray-200"
          >
            <div className="flex items-center space-x-2 mb-4">
              <div className={section.color}>{section.icon}</div>
              <h2 className="text-md md:text-lg font-semibold text-gray-900">{section.title}</h2>
            </div>
            <div className="space-y-2 md:space-y-4">
              {section.items.map((item: string, index: number) => (
                <div key={index} className="flex items-start space-x-2">
                  <div className="w-1 h-1 md:w-2 md:h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0" />
                  <p className="text-xs md:text-sm text-gray-700">{item}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PsychometricFinalRemarksView;
